import { CheckOutlined } from '@ant-design/icons';
import { getCheckboxStyles, getIndeterminateStyles } from './styles.js';
import { jsx } from '@emotion/react';
import vars from '../../../styles/custom-properties.js';

var Checkbox = function Checkbox(_ref) {
  var isChecked = _ref.isChecked,
      isDisabled = _ref.isDisabled,
      isIndeterminate = _ref.isIndeterminate;
  return jsx("span", {
    "aria-checked": isChecked,
    css: function css() {
      return getCheckboxStyles(isDisabled, isChecked, isIndeterminate);
    },
    "data-testid": "checkbox",
    role: "checkbox",
    tabIndex: 0
  }, isIndeterminate && jsx("span", {
    css: function css() {
      return getIndeterminateStyles(isDisabled);
    }
  }), jsx(CheckOutlined, {
    style: {
      fontSize: vars.fontSize12,
      color: isDisabled ? vars.fontColorForInputWhenDisabled : vars.colorSurface,
      visibility: isChecked ? 'visible' : 'hidden',
      display: isIndeterminate ? 'none' : 'flex',
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }));
};
Checkbox.displayName = 'Checkbox';

export { Checkbox };
//# sourceMappingURL=checkbox.js.map
